export const mediumTypes = [
  { label: "Presencial", value: "ONSITE" },
  { label: "En línea", value: "ONLINE" }
];
